import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { InputExcelInfoByFileType } from '@/coreDomainsModule/entities/inputExcelInfo';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';
import { normalizeRegisterOrderExcelInfoDataTypes } from '@/coreDomainsModule/entities/InputOrderExcelInfo';

/**
 * 入力エクセル読み込み情報の取得結果を変換するAdapter
 */
export interface GetInputExcelInfoAdapter<T> {
  /**
   * 保存形式の入力エクセル設定を任意の形式に変換する
   * @param inputExcelInfo - 保存形式の入力エクセル設定
   */
  adapt(inputExcelInfo: InputExcelInfoByFileType): T;
}

/**
 * 入力エクセルの読み込み情報を取得する(全てのファイルタイプについて取得する)
 */
export class GetInputExcelInfoUseCase {
  /**
   * 保存済み入力エクセル設定を現在の形式に補完する
   * @param inputExcelInfo - 保存形式の入力エクセル設定
   */
  private normalizeInputExcelInfo(inputExcelInfo: InputExcelInfoByFileType): InputExcelInfoByFileType {
    return {
      ...inputExcelInfo,
      Order: inputExcelInfo.Order ? normalizeRegisterOrderExcelInfoDataTypes(inputExcelInfo.Order) : inputExcelInfo.Order,
    };
  }

  /**
   *  データを取得する
   * @param repository - リポジトリ
   * @param adapter - 取得結果を変換するAdapter
   */
  public async Execute<T = InputExcelInfoByFileType>(
    repository: InputExcelInfosRepository,
    adapter?: GetInputExcelInfoAdapter<T>
  ): Promise<INetworkResult<T, IError>> {
    try {
      const response = await repository.get();
      if (response.status.type === 'success') {
        const useKey = response.status.data[0];
        const inputExcelInfo = this.normalizeInputExcelInfo(response.status.data[1][useKey]); // 絶対に存在するはず
        return {
          status: {
            type: 'success',
            data: adapter ? adapter.adapt(inputExcelInfo) : (inputExcelInfo as T),
          },
        };
      } else {
        return {
          // 基本的にはここには来ない
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
